import { useState } from 'react'

import useDebounce from 'hooks/useDebounce'

export function useDebouncedValue<TValueType>({
  initialValue,
  debounceWait = 1000,
}: {
  initialValue: TValueType
  debounceWait?: number
}) {
  const [visualValue, setVisualValue] = useState<TValueType>(initialValue)
  const [debouncedValue, setDebouncedValue] = useState<TValueType>(initialValue)

  const { debouncedAction } = useDebounce(setDebouncedValue, debounceWait)

  const handleAction = (value: TValueType) => {
    setVisualValue(value)
    debouncedAction(value)
  }

  return { visualValue, debouncedValue, handleAction }
}
